import DateUtil from "@/plugins/date-util/DateUtil";

/**
 * VueにプラグインとしてDateUtilインスタンスを持たせる
 */
export default {
  install(Vue: any, options: any) {
    Vue.prototype.$dateUtil = new DateUtil();
  }
};

/**
 * Vueの型定義にDateUtilを追加する
 */
declare module "vue/types/vue" {
  interface Vue {
    $dateUtil: DateUtil;
  }
  interface VueConstructor {
    $dateUtil: DateUtil;
  }
}
